<template>
  <div class="news-home">
    <div class="fullwidth narex">
      <div class="title-area flex-start xpad">
        <div class="mtitle"><ix-router-link to="/news">More News</ix-router-link></div>
        <search-widget right :placeholder="$nippets.newsPage.searchText" v-on:select="goArtist" />
      </div>
      <news-story :newsid="id" inpage />
    </div>
  </div>
</template>

<script>
import SearchWidget from '@/components/widgets/BaseSearchWidget.vue'
import NewsStory from './NewsStory.vue'

export default {
  components: {
    SearchWidget,
    NewsStory
  },
  props: {
    id: String
  },
  methods: {
    async goArtist(artist) {
      let t = '/news/tags/' + this.$k.tagToUrl(artist.formatted_name)
      this.$ixr.push(t)
    }
  }
}
</script>
<style scoped>
.mtitle{
  font-size:24px;
  line-height:28px;
}
.xpad{
  margin-bottom:30px;
}
</style>